import { useTheme } from '@redlink/assets/styles';
import { useValues } from '@redlink/assets/values';

export const useOrderTextColor = ({ status, isSelected }) => {
  const { colors } = useTheme();
  const { staticData } = useValues();
  return {
    bodyColor: isSelected
      ? colors.blue1
      : status === staticData.orderStatus.done
      ? colors.green1
      : status === staticData.orderStatus.cancel
      ? colors.red1
      : colors.gray23,
    additionalColor:
      status === staticData.orderStatus.done ||
      status === staticData.orderStatus.cancel
        ? colors.gray21
        : colors.gray23,
    priceColor:
      status === staticData.orderStatus.done ||
      status === staticData.orderStatus.cancel
        ? colors.gray21
        : colors.green1,
  };
};
